import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { Masthead } from "../Masthead";
import { TabBar } from "../TabBar";

export type Chrome = "marketing" | "app" | "bare";

export interface ShellProps {
  chrome: Chrome;
  /** Credit balance for the masthead chip. Wave 1 passes the real number. */
  credits?: number;
  creditsLow?: boolean;
  children: ReactNode;
}

/**
 * One layout for every screen. Marketing routes get the masthead, signed-in
 * routes get the tab bar, and a screen mid flow (capture, reading) gets neither.
 */
export function Shell({ chrome, credits, creditsLow, children }: ShellProps) {
  const location = useLocation();
  const main = useRef<HTMLElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to the main content
      </a>
      {chrome === "marketing" ? <Masthead credits={credits} creditsLow={creditsLow} /> : null}
      <main id="main" ref={main} key={location.pathname} className="screen-in" tabIndex={-1}>
        {children}
      </main>
      {chrome === "app" ? (
        <>
          <div className="tabbar-spacer" aria-hidden="true" />
          <TabBar />
        </>
      ) : null}
    </>
  );
}
